import React from 'react'
import classes from "../contact/contact.module.css"

function Contact() {
  return (
    <div className={classes.contact_main}>
    <div className={classes.contact_title}>Contact Me</div>
    <div className={classes.contact_links}>
        <a href='https://www.linkedin.com/in/ravisankar-bharadwaj-ammanamanchi-735944193/'>LinkedIn</a>
        <a href='https://www.facebook.com/a.r.bharadwaj.1/'>FaceBook</a>
        <a href="mailto:197r1a05c5@gmail.com">Email</a>
        <a href='https://ARBHARADWAJ.github.io/react_port'>Website</a>
    </div>
    </div>
  )
}

export default Contact